import styled from 'styled-components';

export const P = styled.p`
  margin: 0;
  padding: 0;
`;

export default P;

